/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIoeExceptionRequest
 */
export interface UpdateIoeExceptionRequest {
    /**
     * `true` to except the IoE; `false` to remove the exception.
     */
    isDisabled: boolean;
    /**
     * Reason category of the exception. Only used when `is_disabled` is `true`.
     */
    disabledReason?: string | null;
    /**
     * Free-text comment explaining the exception. Only used when `is_disabled` is `true`.
     */
    disabledComment?: string | null;
    /**
     * Optional expiry of the exception. Must be in the future; afterwards the IoE counts again. Omit or `null` for an exception without expiry.
     */
    disabledUntil?: Date | null;
}

/**
 * Check if a given object implements the UpdateIoeExceptionRequest interface.
 */
export function instanceOfUpdateIoeExceptionRequest(value: object): value is UpdateIoeExceptionRequest {
    if ((!('isDisabled' in (value as Record<string, any>)) && !('is_disabled' in (value as Record<string, any>))) || ((value as Record<string, any>)['isDisabled'] === undefined && (value as Record<string, any>)['is_disabled'] === undefined)) return false;
    return true;
}

export function UpdateIoeExceptionRequestFromJSON(json: any): UpdateIoeExceptionRequest {
    return UpdateIoeExceptionRequestFromJSONTyped(json, false);
}

export function UpdateIoeExceptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIoeExceptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isDisabled': json['is_disabled'],
        'disabledReason': json['disabled_reason'] === undefined ? undefined : json['disabled_reason'] === null ? null : json['disabled_reason'],
        'disabledComment': json['disabled_comment'] === undefined ? undefined : json['disabled_comment'] === null ? null : json['disabled_comment'],
        'disabledUntil': json['disabled_until'] === undefined ? undefined : json['disabled_until'] === null ? null : (parseDateTime(json['disabled_until'])),
    };
}

export function UpdateIoeExceptionRequestToJSON(json: any): UpdateIoeExceptionRequest {
    return UpdateIoeExceptionRequestToJSONTyped(json, false);
}

export function UpdateIoeExceptionRequestToJSONTyped(value?: UpdateIoeExceptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_disabled': value['isDisabled'],
        'disabled_reason': value['disabledReason'],
        'disabled_comment': value['disabledComment'],
        'disabled_until': value['disabledUntil'] == null ? value['disabledUntil'] : serializeDateTime(value['disabledUntil']),
    };
}

